import { NewsMixpanelEvents } from '../../constants/mixpanel-events';
import type { ArticleReadSection } from '../trackArticleRead/trackArticleRead';
import { track } from '$global/utils/track';

// The milestones we report, in ascending order. 100% is deliberately excluded:
// reaching the bottom is article completion, which HB-977 owns as its own event.
export const SCROLL_DEPTH_MILESTONES = [25, 50, 75] as const;

export type ScrollDepthMilestone = (typeof SCROLL_DEPTH_MILESTONES)[number];

// Scroll-depth milestone event for the news article surfaces. Mirrors the
// trackArticleRead property shape (article_id + section) so both events join on
// the same keys downstream; `depth` is the milestone crossed, not the raw
// scroll position.
export const trackScrollDepth = ({
	articleId,
	section,
	depth,
}: {
	articleId: string;
	section: ArticleReadSection;
	depth: ScrollDepthMilestone;
}) => {
	track(NewsMixpanelEvents.ScrollDepth, {
		article_id: articleId,
		section,
		depth,
	});
};
